import { InnerBanner } from "container/InnerpageBanner/index2";
import { Crumbs } from "molecules/Breadcrumbs";
import { SectionBorder } from "molecules/SectionBorder";
import { TitleHeading } from "molecules/TitleHeading";
import React, { useState } from "react";
import Modal from "react-modal";
import { FaAngleRight,FaAngleDown } from "react-icons/fa6";
import Divider from "molecules/SimpleBorder/Divider";
import { useSelector } from "react-redux";

export const SocialResponsibility = () => {
  const {
    data: socialData,
    loading,
    error,
  } = useSelector((state) => state.socialResponsibility);

  const { data: dashboardData } = useSelector((state) => state.dashboard);
  
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [openSections, setOpenSections] = useState({});

  const openModal = (section, image) => {
    setSelectedSection(section);
    setSelectedImage(image);
    setModalIsOpen(true);
  };

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      width: "80%",
      maxWidth: "1000px",
      
    },
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className="backgroundThm mobileContainer">
      <div className="container  pl-0">
        <Crumbs />
        

      </div>
      <div className="container pl-0 pr-0 ">
      <InnerBanner
          bannertext={dashboardData?.social_page_description || "Lorem Ipsum is simply dummy text of the printing and typesetting in..."}
          innertitle={"Social Responsibility"}
          image={dashboardData?.social_page_image}
        />
        </div>
        <div className="container px-0">
      <section className="section-padding px-0 pt-0 pb-0">
        <div className="container px-0  lg:pr-0 sm:pr-0 lg:pl-0 sm:pr-0">
          <div className="lg:col-10 md:col-12 sm:col-12 py-4 pl-0" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center' }}>
            <h4 className="fontEb font23 m-0">{dashboardData?.social_page_description_2}</h4>
          </div>
          <div className="lg:col-12 md:col-12 sm:col-12 p-0">
            {socialData?.map((section, i) => {
              const isLastItem = i === socialData.length - 1;
              return (
                <>
                  <Divider key={section.id} />
                  <div
                    className={`section-header d-flex align-items-center justify-content-between py-4 cursor-pointer ${isLastItem ? "mb-2" : ""}`}
                    onClick={() => toggleSection(section.title)}
                  >
                    <h5 className="fontAva fs-21 m-0">{section.title}</h5>
                    {openSections[section.title] ? <FaAngleDown /> : <FaAngleRight />}
                  </div>
                  {openSections[section.title] && (
                    <div className={`section-content ${openSections[section.title] ? "open" : ""}`}>
                      <div className="grid mb-0 p-0 WelfareContainer">
                        {section.images?.map((item, index) => (
                          <div
                            key={item.image_id || index}
                            className="lg:col-4 md:col-4 sm:col-12 pl-1 pr-1"
                            style={{ marginLeft: index === 0 ? '-3px' : '0' }}
                          >
                            <div
                              onClick={() => openModal(section, item)}
                              style={{ cursor: "pointer" }}
                              className={`card1010 ${index === 0 ? "border-bottom-0" : "bg-transparent border-bottom-0"}`}
                            >
                              <img
                                src={item.image}
                                alt={section.title}
                                className="img-fluid"
                              />
                              <h6 className="fs-19 fw-500 my-3 px-0 text-black-alpha-90">
                                {item.title || section.title}
                              </h6>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </div>
      </section>
      </div>
      <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={customStyles} contentLabel="Project Detail Modal">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #C82027",
            marginBottom: "20px",
            width: "100%",
          }}
        >
          <p style={{ fontWeight: "500", fontSize: "20px" }}>
            {selectedImage?.title || selectedSection?.title || "Social Responsibility"}
          </p>
          <button onClick={closeModal} style={{ float: "right" }} className="btn bg-transparent border-none shadow-none p-1 cursor-pointer text-center">
            <i className="pi pi-times thm-red fs-25"></i>
          </button>
        </div>
        <div className="containerNew" style={{ display: "flex", alignItems: "flex-start" }}>
          <div className="column1 p-0 pt-3">
            <div className="mb-4">
              <div style={{ display: "flex", flexDirection: 'row', flexWrap: 'wrap' }}>
                <div className="" style={{ width: '50%' }}>
                  <p className="font17" style={{ width: '50%', marginBottom: '-1%', fontWeight: 600 }}>Cause:</p>
                  <span className="font17">{selectedSection?.title || ""}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="column1 image-container" style={{ position: "relative" }}>
            <img
              src={selectedImage?.image}
              alt={selectedImage?.title || selectedSection?.title || ""}
              className="img-fluid"
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};
